import { ref, markRaw } from 'vue'

export function useModal() {
  const modals = ref([])

  function openModal(component, props = {}) {
    return new Promise((resolve, reject) => {
      const id = Date.now()
      modals.value.push({
        id,
        component: markRaw(component),
        props,
        resolve,
        reject
      })
    })
  }

  function closeModal(id, result) {
    const modalIndex = modals.value.findIndex((modal) => modal.id === id)
    if (modalIndex !== -1) {
      modals.value[modalIndex].resolve(result)
      modals.value.splice(modalIndex, 1)
    }
  }

  /**
   * Creates and opens a modal window.
   *
   * @param {Object} config - The configuration for the modal window.
   * @param {Object} config.component - The Vue component to be rendered inside the modal.
   * @param {Object} [config.props={}] - Props to be passed to the modal component.
   *
   * @returns {Promise} - Returns a Promise that resolves with the result passed when the modal is closed.

   */
  async function createModal(config) {
    const { component, props = {} } = config
    return await openModal(component, props)
  }

  return {
    modals,

    closeModal,
    createModal
  }
}
